import React, { Component } from 'react';
import { Translate } from '$common';



export default class ImageUpload extends Component {
  static type = 'image_upload';
  static elementName = Translate.get('image_upload');
  static icon = 'picture-o';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/image-upload.js